import React from "react";
import useFetch from "../hooks/useFetch";
import bannerBG from "../css/images/banner-bg.svg";

export default function StaSection({ onOpen }) {
  const staFetch = useFetch(`${window.$host}/api/sta`);

  if (staFetch.loading) return;
  if (staFetch.error) return;

  return (
    <section className="bg-blue banner">
      <div className="banner__bg">
        <img src={bannerBG} alt="#" />
      </div>
      <div className="container">
        <div className="h-100 banner__box">
          <div className="banner__title">
            <h2 className="title-2 text-white">{staFetch.data.data.Title}</h2>{" "}
            <h3 className="title-2 text-purple">
              {staFetch.data.data.TitlePurple}
            </h3>
          </div>
          <div>
            <button className="dark-arrow" onClick={onOpen}>
              <span className="dark-arrow__text">Запустить продукт</span>
              <span className="dark-arrow__arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="12"
                  viewBox="0 0 17 12"
                  fill="none"
                >
                  <circle
                    cx="4"
                    cy="6"
                    r="1"
                    transform="rotate(90 4 6)"
                    fill="white"
                  />
                  <circle
                    cx="1"
                    cy="6"
                    r="1"
                    transform="rotate(90 1 6)"
                    fill="white"
                  />
                  <circle
                    cx="7"
                    cy="6"
                    r="1"
                    transform="rotate(90 7 6)"
                    fill="white"
                  />
                  <circle
                    cx="10"
                    cy="6"
                    r="1"
                    transform="rotate(90 10 6)"
                    fill="white"
                  />
                  <circle
                    cx="13"
                    cy="6"
                    r="1"
                    transform="rotate(90 13 6)"
                    fill="white"
                  />
                  <circle
                    cx="16"
                    cy="6"
                    r="1"
                    transform="rotate(90 16 6)"
                    fill="white"
                  />
                  <circle
                    cx="13"
                    cy="9"
                    r="1"
                    transform="rotate(90 13 9)"
                    fill="white"
                  />
                  <circle
                    cx="13"
                    cy="3"
                    r="1"
                    transform="rotate(90 13 3)"
                    fill="white"
                  />
                  <circle
                    cx="10"
                    cy="0.500001"
                    r="0.5"
                    transform="rotate(90 10 0.500001)"
                    fill="white"
                  />
                  <circle
                    cx="10"
                    cy="11.5"
                    r="0.5"
                    transform="rotate(90 10 11.5)"
                    fill="white"
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
